import React, { useEffect,useRef } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { Button } from "@mui/material";
import Footer from "./Footer";
import { Link, useNavigate,useLocation } from "react-router-dom";
import { Elements } from '@stripe/react-stripe-js';
import apiService from "../core/service/detail";
import { loadStripe } from '@stripe/stripe-js';
import { postMethod ,checkoutSession } from "../core/service/common.api";
import { toast } from "react-toastify";
const stripePromise = loadStripe('pk_test_51Qc2b0ECPP2E9B1Z9ZoTjU0UoCl9Avty2LaCPGVQfwOlvMyCcPuZkT7VqYCxgJ3EmrpQv4zCFAIHt4gzZC4qldBM005c3yoUdg'); // Publishable Key


function Pricing() {
    const location = useLocation();
    const hasProcessedSessionRef = useRef(false);
    const [loginCheck, setloginCheck] = useState(false);

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const sessionId = query.get("session_id");

        if (sessionId && !hasProcessedSessionRef.current) {
          hasProcessedSessionRef.current = true; // Flag as processed
          toast.success('Payment Successfull');
        }

        
      }, [location.search]);

      useEffect(()=>{
        let userToken = localStorage.getItem("user_token");

    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
      },[0])


  const navigate = useNavigate();

  const handleShowPaymentForm = async (amount, planname) => {
    try {
      if (!loginCheck) {
        navigate('/login'); 
        return;
      }
        const amountInCents = Math.max(amount * 100, 5000);  

      const formValue = {
        amount: amountInCents,
        planname: planname,
      };
  
      var data = {
        apiUrl: apiService.checkout,
        payload: formValue,
      };
  
      var response = await checkoutSession(data);
  
      // Check for a valid URL response
      if (response.data.url) {
        const stripe = await stripePromise;
        
        // Redirect to Stripe checkout
        stripe.redirectToCheckout({ sessionId: response.data.id });
        
      }
    } catch (error) {
      toast.error(error.response?.data || error.message)
      console.error("Error during payment process:", error.response?.data || error.message);
    }
  };
  
  

  

  return (
    <div className="header ">
      <Header />
      <main className="safest-payment-gateway">
      <section className="use-case-section otp_section_head">
            <div className="container otp_section_container">
              <div className="use-case-title otp-section_plan">
                <h2>OTP Generation Plans</h2>
                <p>
                Secure your platform with reliable OTP services tailored to your needs. Whether you're just starting or scaling globally, our subscription plans provide seamless SMS, email, and voice-based OTP delivery. Enjoy fast, secure, and customizable options designed to fit businesses of all sizes. Select a plan and start protecting your users today!
                </p>
              </div>
              <div className="backgrd_grillimg">
              <div className="row">
                <div className="col-lg-3">
                  <div className="use-case-card subscript_col" >
                   <div className="plan_details">
                    <button className="basic_btn">Basic Plan</button>
                    <div className="features_tag">
                        <h4>Features</h4>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">SMS and Email OTPs</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list basic_reportdetails">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Basic reporting (success/failure rates)</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list basic_reportdetails">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Standard delivery speed (2-5 seconds per OTP)</span></p>
                </div>
              </div>
              <div className="plan_cost_details">
                <h4> $10<span className="month_plan">/month</span></h4>
              </div>
              <div className="purchase_details">
  <button onClick={() => handleShowPaymentForm('10', 'Basic Plan')}>Purchase</button>
</div>
              <div className="limit_plan">
                <p>
                Limit
                </p>
                <p> 1,000 OTPs</p>
              </div>
                    </div>
                   </div>
                  </div>
                </div>
                <div className="col-lg-3">
                <div className="use-case-card subscript_col">
                <div className="plan_details">
                    <button className="basic_btn">Standard Plan</button>
                    <div className="features_tag">
                        <h4>Features</h4>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">All Starter Plan features</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Faster delivery (1-3 seconds)</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Voice OTPs</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Retry on failure</span></p>
                </div>
              </div>
              <div className="plan_cost_details">
                <h4> $50<span className="month_plan">/month</span></h4>
              </div>
              <div className="purchase_details">
  <button onClick={() => handleShowPaymentForm('50', 'Standard Plan')}>Purchase</button>
</div>
              <div className="limit_plan">
                <p>
                Limit
                </p>
                <p>10,000 OTPs</p>
              </div>
                    </div>
                   </div>
                   </div>
                </div>
                <div className="col-lg-3">
                <div className="use-case-card subscript_col">
                <div className="plan_details">
                    <button className="basic_btn">Premium Plan</button>
                    <div className="features_tag">
                        <h4>Features</h4>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">All Growth Plan features</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list"> Global OTP delivery</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list"> Custom sender name (for SMS)</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list"> Advanced analytics</span></p>
                </div>
              </div>
              <div className="plan_cost_details">
                <h4> $150<span className="month_plan">/month</span></h4>
              </div>
              <div className="purchase_details">
  <button onClick={() => handleShowPaymentForm('150', 'Premium Plan')}>Purchase</button>
</div>
              <div className="limit_plan">
                <p>
                Limit
                </p>
                <p>50,000 OTPs</p>
              </div>
                    </div>
                   </div>
                   </div>
                </div>
                <div className="col-lg-3">
                <div className="use-case-card subscript_col">
                <div className="plan_details">
                    <button className="basic_btn">Enterprise Plan</button>
                    <div className="features_tag">
                        <h4>Features</h4>
                        <div className="free_details_wholesec">
                <div className="free_details_list">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list"> SMS and Email OTPs</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list basic_reportdetails">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Basic reporting (success/failure rates)</span></p>
                </div>
              </div>
                        <div className="free_details_wholesec">
                <div className="free_details_list basic_reportdetails">
                  <span className="backgrd_circle"><i class="fa-solid fa-check"></i></span>
                </div>
                <div className="free_details_list">
                  <p><span className="header_details_list">Standard delivery speed (2-5 seconds per OTP)</span></p>
                </div>
              </div>
              <div className="plan_cost_details">
                <h4>Custom<span className="month_plan"> Pricing</span></h4>
              </div>
              <div className="purchase_details">
  <button onClick={() => handleShowPaymentForm('200', 'Enterprise Plan')}>Purchase</button>
</div>
              <div className="limit_plan">
                <p>
                Limit
                </p>
                <p>1,000 OTPs</p>
              </div>
                    </div>
                   </div>
                   </div>
                </div>
              </div>
              </div>
             
            </div>
          </section>
      </main>
    </div>
  );
}

export default Pricing;